// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  
  //LOCALHOST
  // production: false,
  // apiEndpoint: 'https://api.worryandpeace.com',
  // membrsEndpoint: 'https://staging.memb.rs/api/v1',
  // membrsLoginPage: 'https://marketplace-local.staging.memb.rs/login',
  // envName: 'local',
  // cookieDomain: 'localhost',
  // marketplaceUrl: 'https://beta.marketplace.worryandpeace.com'

//Next Gen Dev
  // production: false,
  // apiEndpoint: 'https://api.worryandpeace.com',
  // membrsEndpoint: 'https://staging.memb.rs/api/v1',
  // membrsLoginPage: 'https://apollo11.dev.cycler.co.uk',
  // envName: 'dev',
  // cookieDomain: '.worryandpeace.com',
  // marketplaceUrl: 'https://marketplace-dev.worryandpeace.com'

  // production: true,
  // apiEndpoint: 'https://api.worryandpeace.com',
  // membrsEndpoint: 'https://staging.memb.rs/api/v1',
  // membrsLoginPage: 'https://marketplace-dev.staging.memb.rs/login',
  // envName: 'dev',
  // cookieDomain: '.worryandpeace.com'



    //Pouch
  // production: true,
  // apiEndpoint: 'https://api.worryandpeace.com',
  // membrsEndpoint: 'https://staging.memb.rs/api/v1',
  // membrsLoginPage: 'https://pouch.staging.memb.rs/login',
  // envName: 'prod',
  // marketplaceUrl: 'https://juno.marketplace.worryandpeace.com',
  // cookieDomain: '.marketplace.worryandpeace.com'

  //Worry+Peace Dev
  // production: true,
  // apiEndpoint: 'https://api.worryandpeace.com',
  // membrsEndpoint: 'https://staging.memb.rs/api/v1',
  // membrsLoginPage: 'https://as.dev.peaccce.com/login',
  // envName: 'prod',
  // marketplaceUrl: 'https://beta.marketplace.worryandpeace.com',
  // cookieDomain: '.worryandpeace.com'

  //Rooster
  // production: true,
  // apiEndpoint: 'https://api.worryandpeace.com',
  // membrsEndpoint: 'https://staging.memb.rs/api/v1',
  // membrsLoginPage: 'https://thi.peaccce.com/login',
  // envName: 'prod',
  // marketplaceUrl: 'https://beta.marketplace.worryandpeace.com',
  // cookieDomain: '.marketplace.worryandpeace.com'


  ///////// PRODUCTION //////////


    //Next Gen
  // production: true,
  // apiEndpoint: 'https://api.worryandpeace.com',
  // membrsEndpoint: 'https://staging.memb.rs/api/v1',
  // membrsLoginPage: 'https://apollo11.cycler.co.uk',
  // envName: 'prod',
  // marketplaceUrl: 'https://beta.marketplace.worryandpeace.com',
  // cookieDomain: '.marketplace.worryandpeace.com'

    //Worry+Peace
  // production: true,
  // apiEndpoint: 'https://api.worryandpeace.com',
  // membrsEndpoint: 'https://staging.memb.rs/api/v1',
  // membrsLoginPage: 'https://as.peaccce.com/login',
  // envName: 'prod',
  // marketplaceUrl: 'https://beta.marketplace.worryandpeace.com',
  // cookieDomain: '.worryandpeace.com'

  //Rooster
  production: true,
  apiEndpoint: 'https://api.worryandpeace.com',
  membrsEndpoint: 'https://staging.memb.rs/api/v1',
  membrsLoginPage: 'https://rooster.peaccce.com',
  envName: 'prod',
  marketplaceUrl: 'https://beta.marketplace.worryandpeace.com',
  cookieDomain: '.marketplace.worryandpeace.com'

  //Juno
  // production: true,
  // apiEndpoint: 'https://api.worryandpeace.com',
  // membrsEndpoint: 'https://staging.memb.rs/api/v1',
  // membrsLoginPage: 'https://admin.juno.insure/login',
  // envName: 'prod',
  // marketplaceUrl: 'https://beta.marketplace.worryandpeace.com',
  // cookieDomain: '.marketplace.worryandpeace.com'

  //The Home Insurer
  // production: true,
  // apiEndpoint: 'https://api.worryandpeace.com',
  // membrsEndpoint: 'https://staging.memb.rs/api/v1',
  // membrsLoginPage: 'https://thi.peaccce.com/login',
  // envName: 'prod',
  // marketplaceUrl: 'https://beta.marketplace.worryandpeace.com',
  // cookieDomain: '.marketplace.peaccce.com'

};



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/rooster/admin/src/environments/environment.ts